/* eslint-disable @typescript-eslint/no-explicit-any */

import { ResizeBox } from "@/components/shared/resize-box";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import {
  /* EyeIcon, */ PencilIcon,
  Trash2Icon,
  TriangleIcon,
} from "lucide-react";
import { ReactTableCell } from "../react-table-cell/react-table-cell";
import { SwitchRenderer } from "@/components/shared/switch-renderer";
import { ReactTableHeader } from "@/components/shared/react-table-header";
import { CustomReactTableHeader } from "@/components/shared/custom-react-table-header";
import { useUserInfo } from "@/global-data/use-user-info";

export const ReactTable = ({
  tableHeader,
  onResize,
  table,
  // permission,
  onAction,
  // retailerList,
  filter,
  setFilter,
  listData,
  filterRequest,
  sortingHandler,
  sortBy,
  orderBy,
  sncCustomerList,
}: any) => {
  const { activePermission } = useUserInfo();
  return (
    <Table style={{ borderCollapse: "collapse", width: "100%" }}>
      <TableHeader>
        <TableRow>
          <TableHead className="hidden">
            <input type="checkbox" />
          </TableHead>
          {tableHeader?.map((header: any, index: number) => (
            <TableHead
              key={header.accessorKey}
              style={{
                width: header.width,
                minWidth: header.minWidth,
                maxWidth: header.maxWidth,
              }}
              className={cn({ "pl-5": index === 0 })}
            >
              <ResizeBox
                width={header.width}
                onResize={(props: any) =>
                  onResize({ size: props, key: header.accessorKey })
                }
              >
                <SwitchRenderer
                  type={header.header}
                  components={{
                    Retailers: (
                      <CustomReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={[]}
                        setFilter={setFilter}
                        filter={filter}
                        bindLabel="retailer_name"
                        bindValue="retailer_id"
                        isHide={listData?.length === 0}
                        filterRequest={filterRequest}
                      >
                        <span
                          onClick={() => sortingHandler(header.accessorKey)}
                          className="flex items-center gap-1 w-full"
                        >
                          Retailers
                          <span>
                            {sortBy === header.accessorKey ? (
                              <TriangleIcon
                                className={cn(orderBy ? "rotate-180" : "")}
                                fill="#1f2937"
                                stroke="#1f2937"
                                size={8}
                              />
                            ) : (
                              <span>
                                <TriangleIcon
                                  fill="#1f2937"
                                  stroke="#1f2937"
                                  size={8}
                                />
                                <TriangleIcon
                                  className={"rotate-180"}
                                  fill="#1f2937"
                                  stroke="#1f2937"
                                  size={8}
                                />
                              </span>
                            )}
                          </span>
                        </span>
                      </CustomReactTableHeader>
                    ),
                    Uom: <span>Po Uom</span>,
                    default: (
                      <ReactTableHeader
                        label={header.header}
                        key={header.accessorKey}
                        header={header.accessorKey}
                        table={listData}
                        setFilter={setFilter}
                        filter={filter}
                        filterRequest={filterRequest}
                      >
                        <span>{header.header}</span>
                      </ReactTableHeader>
                    ),
                  }}
                />
                {/* <ReactTableHeader
                  label={header.header}
                  key={header.accessorKey}
                  header={header.accessorKey}
                  table={listData}
                  setFilter={setFilter}
                  filter={filter}
                  filterRequest={filterRequest}
                >
                  <SwitchRenderer
                    type={header.header}
                    components={{
                      "Retailer id": <span>Retailer Name</span>,
                      default: <span>{header.header}</span>,
                    }}
                  />
                </ReactTableHeader> */}
              </ResizeBox>
            </TableHead>
          ))}
          <TableHead className="text-center sticky right-0 z-[2] w-auto pr-0">
            <div className="flex justify-end">
              <div className="w-[66px] md:w-[100px] text-left pl-[8px]">
                Actions
              </div>
            </div>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {table.map((row: any, rowIndex: number) => (
          <TableRow key={row.id + rowIndex}>
            <TableCell className="w-[30px] hidden">
              <input type="checkbox" />
            </TableCell>
            {row.data.map((cell: any, index: number) => (
              <TableCell
                key={cell.key + index}
                width={cell.width}
                style={{ width: cell.width }}
                className={cn({ "pl-3": index === 0 })}
              >
                <ReactTableCell
                  header={cell.key}
                  value={cell.value}
                  sncCustomerList={sncCustomerList}
                />
              </TableCell>
            ))}
            <TableCell
              className="text-right sticky right-0 w-auto bg-white"
              nestedClassName="pr-0"
            >
              <div className="flex items-center justify-end z-[2] bg-white">
                <div className="flex items-center w-[66px] md:w-[100px]">
                  <TooltipProvider>
                    {activePermission?.update ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            className="text-primary"
                            onClick={() =>
                              onAction({ data: row.originData, action: "edit" })
                            }
                          >
                            <PencilIcon />
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p>Edit</p>
                          <TooltipArrow />
                        </TooltipContent>
                      </Tooltip>
                    ) : null}

                    {activePermission?.delete ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            variant={"ghost"}
                            size={"icon"}
                            className="text-primary"
                            onClick={() =>
                              onAction({
                                data: row.originData,
                                action: "delete",
                              })
                            }
                          >
                            <Trash2Icon />
                          </Button>
                        </TooltipTrigger>

                        <TooltipContent>
                          <p>Delete</p>
                          <TooltipArrow />
                        </TooltipContent>
                      </Tooltip>
                    ) : null}
                  </TooltipProvider>
                </div>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
